// import React, { useEffect, useState } from "react";
// import { TextInput, SelectInput, DateInput } from "../../Components/Inputs";
// import init_records from "../init_records";
// import Btn from "../../../../Components/Buttons/Btn";
// import { useNavigate } from "react-router-dom";
// import useAxios from "../../../../Hooks/useAxios";
// import useForm from "../../Components/hooks/useForm";
// import SearchableSelect from "../../Components/Inputs/SearchableSelect";
// import useApp from "../../../../Hooks/useApp";

// const Add = () => {
//   const [input, setInput] = useState(init_records);
//   const navigate = useNavigate();
//   const [vehicles, setVehicles] = useState({});
//   const { user } = useApp();
//   const request = useAxios();

//   useEffect(() => {
//     getConfig();
//   }, []);

//   // Handle the form submission and send data to the API
//   const handleSubmit = async (data) => {
//     const payload = {
//       ...data,
//       nano_receipt: input.nano_receipt || null,
//     };

//     // Log payload to ensure all fields are included
//     console.log("Payload being sent to API:", payload);

//     let res = await request({
//       method: "POST",
//       url: "fuel/add",
//       body: payload,
//     });

//     if (res === "error") return;
//     navigate("/dashboard/fuel");
//   };

//   const { handleValidation, validate } = useForm({
//     input,
//     submit: handleSubmit,
//   });

//   async function getConfig() {
//     let res = await request({
//       method: "get",
//       url: "config",
//       show_loading: false,
//       show_error: false,
//     });
//     if (res !== "error") {

//     }
//   }

//   // Handle file change and convert file to Base64
//   const handleFileChange = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onloadend = () => {
//       const base64String = reader.result.split(",")[1];
//       setInput((prev) => ({
//         ...prev,
//         nano_receipt: base64String,
//       }));
//     };
//     reader.readAsDataURL(file);
//   };

//   return (
//     <div className="shadow-2xl w-[85%] m-auto border-t p-4 mt-12">
//       <h3 className="text-center text-xl font-semibold">Add Fuel Record</h3>
//       <div className="mt-4">
//         <div className="flex gap-5 items-center max-md:flex-col">
//           <DateInput
//             input={input}
//             setInput={setInput}
//             field="fuel_date"
//             validate={validate}
//             label="Fuel Date"
//           />
//           <SearchableSelect
//             input={input}
//             setInput={setInput}
//             field="vehicle_id"
//             validate={validate}
//             url="vehicles/search-vehicle"
//             setOptions={setVehicles}
//           >
//             {vehicles?.docs?.map((vehicle, i) => (
//               <option value={vehicle?.id} key={i} label={vehicle.plate_no}>
//                 {vehicle?.plate_no}
//               </option>
//             ))}
//           </SearchableSelect>
//         </div>

//         <div className="flex gap-5 items-center max-md:flex-col">
//           <TextInput
//             input={input}
//             setInput={setInput}
//             field="fueled_by"
//             validate={validate}
//             label="Fueled By"
//           />
//           <TextInput
//             input={input}
//             setInput={setInput}
//             field="trip_id"
//             validate={validate}
//             label="Trip"
//           />
//         </div>

//         <div className="flex gap-5 items-center max-md:flex-col">
//           <TextInput
//             input={input}
//             setInput={setInput}
//             field="fuel_amount"
//             validate={validate}
//             label="Fuel Amount (Liters)"
//           />
//           <TextInput
//             input={input}
//             setInput={setInput}
//             field="price_per_litre"
//             validate={validate}
//             label="Price Per Litre"
//           />
//         </div>

//         <div className="flex gap-5 items-center max-md:flex-col">
//           <TextInput
//             input={input}
//             setInput={setInput}
//             field="cost"
//             validate={validate}
//             label="Total Cost"
//           />
//           <TextInput
//             input={input}
//             setInput={setInput}
//             field="filling_station"
//             validate={validate}
//             label="Filling Station"
//           />
//         </div>

//         {/* File Upload Section */}
//         <div className="flex gap-5 items-center max-md:flex-col">
//           <div className="flex-1 w-full">
//             <label className="text-center text-xl font-semibold text-[#1f3569]">
//               Upload Receipt
//             </label>
//             <input
//               type="file"
//               accept="image/*, application/pdf"
//               onChange={handleFileChange}
//               className="w-full border border-gray-300 rounded px-3 py-2 text-sm text-gray-700"
//             />
//           </div>
//         </div>
//       </div>

//       <div className="mt-4 flex justify-between">
//         <Btn onClick={() => navigate("/dashboard/fuel")}>Back</Btn>
//         <Btn onClick={handleValidation}>Submit</Btn>
//       </div>
//     </div>
//   );
// };

// export default Add;

// import React, { useEffect, useState } from "react";
// import { TextInput, SelectInput, DateInput } from "../../Components/Inputs";
// import init_records from "../init_records";
// import Btn from "../../../../Components/Buttons/Btn";
// import { useNavigate } from "react-router-dom";
// import useAxios from "../../../../Hooks/useAxios";
// import useForm from "../../Components/hooks/useForm";
// import SearchableSelect from "../../Components/Inputs/SearchableSelect";
// import useApp from "../../../../Hooks/useApp";

// const Add = () => {
//   const [input, setInput] = useState(init_records);
//   const navigate = useNavigate();
//   const [vehicles, setVehicles] = useState({});
//   const [members, setMembers] = useState({});
//   const [scheduling, setScheduling] = useState([]);
//   const [receiptFile, setReceiptFile] = useState(null);
//   const { user } = useApp();
//   const request = useAxios();

//   useEffect(() => {
//     getConfig();
//     getMembers();
//     getSchedules();
//   }, []);

//   // Handle the form submission and send data to the API
//   const handleSubmit = async (data) => {
//     const formData = new FormData();
//     formData.append("fuel_date", data.fuel_date);
//     formData.append("vehicle_id", data.vehicle_id);
//     formData.append("fueled_by", data.fueled_by);
//     formData.append("trip_id", data.trip_id);
//     formData.append("fuel_amount", data.fuel_amount);
//     formData.append("price_per_litre", data.price_per_litre);
//     formData.append("cost", data.cost);
//     formData.append("filling_station", data.filling_station);

//     if (receiptFile) {
//       formData.append("nano_receipt", receiptFile);
//     }

//     let res = await request({
//       method: "POST",
//       url: "fuel/add",
//       body: formData,
//       // headers: { "Content-Type": "multipart/form-data" },
//     });
//     console.log("API response:", res);

//     if (res === "error") return;
//     navigate("/dashboard/fuel");
//   };

//   const { handleValidation, validate } = useForm({
//     input,
//     submit: handleSubmit,
//   });

//   // Fetch config, users, and trips data
//   async function getConfig() {
//     let res = await request({
//       method: "get",
//       url: "config",
//       show_loading: false,
//       show_error: false,
//     });
//     if (res !== "error") {
//       // Process config data if needed
//     }
//   }

//   async function getMembers() {
//     let res = await request({
//       method: "get",
//       url: "members/search",
//       show_loading: false,
//       show_error: false,
//     });
//     if (res !== "error") {
//       setMembers(res);
//     }
//   }

//   async function getSchedules() {
//     let res = await request({
//       method: "get",
//       url: "scheduling/search",
//       show_loading: false,
//       show_error: false,
//     });
//     if (res !== "error") {
//       setScheduling(res);
//     }
//   }

//   // Handle file change and convert file to Base64
//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     setReceiptFile(file);
//   };

//   return (
//     <div className="shadow-2xl w-[85%] m-auto border-t p-4 mt-12">
//       <h3 className="text-center text-xl font-semibold">Add Fuel Record</h3>
//       <div className="mt-4">
//         <div className="flex gap-5 items-center max-md:flex-col">
//           <DateInput
//             input={input}
//             setInput={setInput}
//             field="fuel_date"
//             validate={validate}
//             label="Fuel Date"
//           />
//           <SearchableSelect
//             input={input}
//             setInput={setInput}
//             field="vehicle_id"
//             validate={validate}
//             url="vehicles/search-vehicle"
//             setOptions={setVehicles}
//           >
//             {vehicles?.docs?.map((vehicle, i) => (
//               <option value={vehicle?.id} key={i} label={vehicle.plate_no}>
//                 {vehicle?.plate_no}
//               </option>
//             ))}
//           </SearchableSelect>
//         </div>

//         <div className="flex gap-5 items-center max-md:flex-col">
//           {/* User Dropdown (Fueled By) */}
//           <SearchableSelect
//             input={input}
//             setInput={setInput}
//             field="fueled_by"
//             validate={validate}
//             url="members/search"
//             setOptions={setMembers}
//           >
//             {members?.docs?.map((member, i) => (
//               <option value={member?.id} key={i} label={member.name}>
//                 {member?.name}
//               </option>
//             ))}
//           </SearchableSelect>

//           {/* Trip Dropdown */}
//           <SearchableSelect
//             input={input}
//             setInput={setInput}
//             field="trip_id"
//             validate={validate}
//             url="scheduling/search"
//             setOptions={setScheduling}
//           >
//             {Array.isArray(scheduling?.docs) && scheduling.docs.length > 0 ? (
//               scheduling.docs.map((sched, i) => (
//                 <option key={i} value={sched.id}>
//                   {sched.dispatch_scheduling?.departure_point &&
//                   sched.dispatch_scheduling?.destination
//                     ? `${sched.dispatch_scheduling.departure_point} - ${sched.dispatch_scheduling.destination}`
//                     : `${sched.departure_point} - ${sched.destination}`}
//                 </option>
//               ))
//             ) : (
//               <option disabled>No scheduled trips available</option>
//             )}
//           </SearchableSelect>
//         </div>

//         <div className="flex gap-5 items-center max-md:flex-col">
//           <TextInput
//             input={input}
//             setInput={setInput}
//             field="fuel_amount"
//             validate={validate}
//             label="Fuel Amount (Liters)"
//           />
//           <TextInput
//             input={input}
//             setInput={setInput}
//             field="price_per_litre"
//             validate={validate}
//             label="Price Per Litre"
//           />
//         </div>

//         <div className="flex gap-5 items-center max-md:flex-col">
//           <TextInput
//             input={input}
//             setInput={setInput}
//             field="cost"
//             validate={validate}
//             label="Total Cost"
//           />
//           <TextInput
//             input={input}
//             setInput={setInput}
//             field="filling_station"
//             validate={validate}
//             label="Filling Station"
//           />
//         </div>

//         {/* File Upload Section */}
//         <div className="flex gap-5 items-center max-md:flex-col">
//           <div className="flex-1 w-full">
//             <label className="text-center text-xl font-semibold text-[#1f3569]">
//               Upload Receipt
//             </label>
//             <input
//               type="file"
//               accept="image/*, application/pdf"
//               onChange={handleFileChange}
//               className="w-full border border-gray-300 rounded px-3 py-2 text-sm text-gray-700"
//             />
//           </div>
//         </div>
//       </div>

//       <div className="mt-4 flex justify-between">
//         <Btn onClick={() => navigate("/dashboard/fuel")}>Back</Btn>
//         <Btn onClick={handleValidation}>Submit</Btn>
//       </div>
//     </div>
//   );
// };

// export default Add;



import React, { useEffect, useState } from "react";
import { TextInput, DateInput } from "../../Components/Inputs";
import init_records from "../init_records";
import Btn from "../../../../Components/Buttons/Btn";
import { useNavigate } from "react-router-dom";
import useFileAxios from "../../../../Hooks/useFileAxios";
import useForm from "../../Components/hooks/useForm";
import SearchableSelect from "../../Components/Inputs/SearchableSelect";
import useApp from "../../../../Hooks/useApp";

const Add = () => {
  const [input, setInput] = useState(init_records);
  const [vehicles, setVehicles] = useState({});
  const [members, setMembers] = useState({});
  const [scheduling, setScheduling] = useState([]);
  const [receiptFile, setReceiptFile] = useState(null);

  const { user } = useApp();
  const fileRequest = useFileAxios(); // ✅ updated
  const navigate = useNavigate();

  useEffect(() => {
    getConfig();
    getMembers();
    getSchedules();
  }, []);

  const handleSubmit = async (data) => {
    const formData = new FormData();

    Object.entries({
      fuel_date: data.fuel_date,
      vehicle_id: data.vehicle_id,
      fueled_by: data.fueled_by,
      trip_id: data.trip_id,
      fuel_amount: data.fuel_amount,
      price_per_litre: data.price_per_litre,
      cost: data.cost,
      filling_station: data.filling_station,
    }).forEach(([key, value]) => {
      formData.append(key, value ?? "");
    });

    if (receiptFile) {
      formData.append("nano_receipt", receiptFile);
    }

    // ✅ Log the FormData here
    for (let [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }

    try {
      const res = await fileRequest({
        method: "POST",
        url: "fuel/add",
        body: formData,
      });

      console.log("API response:", res); // Optional: to inspect backend response

      if (res !== "error") {
        navigate("/dashboard/fuel");
      }
    } catch (err) {
      console.error("Submission error:", err);
    }
  };


  const { handleValidation, validate } = useForm({
    input,
    submit: handleSubmit,
  });

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) setReceiptFile(file);
  };

  const getConfig = async () => {
    await fileRequest({
      method: "get",
      url: "config",
      show_loading: false,
      show_error: false,
    });
  };

  const getMembers = async () => {
    const res = await fileRequest({
      method: "get",
      url: "members/search",
      show_loading: false,
      show_error: false,
    });
    if (res !== "error") setMembers(res);
  };

  const getSchedules = async () => {
    const res = await fileRequest({
      method: "get",
      url: "scheduling/search",
      show_loading: false,
      show_error: false,
    });
    if (res !== "error") setScheduling(res);
  };

  return (
    <div className="shadow-2xl w-[85%] m-auto border-t p-4 mt-12">
      <h3 className="text-center text-xl font-semibold">Add Fuel Record</h3>

      {/* Date and Vehicle Selection */}
      <div className="flex gap-5 items-center max-md:flex-col mt-4">
        <DateInput
          input={input}
          setInput={setInput}
          field="fuel_date"
          validate={validate}
          label="Fuel Date"
        />
        <SearchableSelect
          input={input}
          setInput={setInput}
          field="vehicle_id"
          validate={validate}
          url="vehicles/search-vehicle"
          setOptions={setVehicles}
        >
          {vehicles?.docs?.map((vehicle, i) => (
            <option value={vehicle.id} key={i} label={vehicle.plate_no}>
              {vehicle.plate_no}
            </option>
          ))}
        </SearchableSelect>
      </div>

      {/* Fueled By and Trip */}
      <div className="flex gap-5 items-center max-md:flex-col mt-4">
        <SearchableSelect
          input={input}
          setInput={setInput}
          field="fueled_by"
          validate={validate}
          url="members/search"
          setOptions={setMembers}
        >
          {members?.docs?.map((member, i) => (
            <option value={member.id} key={i} label={member.name}>
              {member.name}
            </option>
          ))}
        </SearchableSelect>

        <SearchableSelect
          input={input}
          setInput={setInput}
          field="trip_id"
          validate={validate}
          url="scheduling/search"
          setOptions={setScheduling}
        >
          {Array.isArray(scheduling?.docs) && scheduling.docs.length > 0 ? (
            scheduling.docs.map((sched, i) => (
              <option key={i} value={sched.id}>
                {sched.dispatch_scheduling?.departure_point
                  ? `${sched.dispatch_scheduling.departure_point} - ${sched.dispatch_scheduling.destination}`
                  : `${sched.departure_point} - ${sched.destination}`}
              </option>
            ))
          ) : (
            <option disabled>No scheduled trips available</option>
          )}
        </SearchableSelect>
      </div>

      {/* Fuel and Price Inputs */}
      <div className="flex gap-5 items-center max-md:flex-col mt-4">
        <TextInput
          input={input}
          setInput={setInput}
          field="fuel_amount"
          validate={validate}
          label="Fuel Amount (Liters)"
        />
        <TextInput
          input={input}
          setInput={setInput}
          field="price_per_litre"
          validate={validate}
          label="Price Per Litre"
        />
      </div>

      {/* Cost and Station */}
      <div className="flex gap-5 items-center max-md:flex-col mt-4">
        <TextInput
          input={input}
          setInput={setInput}
          field="cost"
          validate={validate}
          label="Total Cost"
        />
        <TextInput
          input={input}
          setInput={setInput}
          field="filling_station"
          validate={validate}
          label="Filling Station"
        />
      </div>

      {/* File Upload */}
      <div className="flex flex-col mt-4">
        <label className="text-xl font-semibold text-[#1f3569]">
          Upload Receipt
        </label>
        <input
          type="file"
          accept="image/*, application/pdf"
          onChange={handleFileChange}
          className="border border-gray-300 rounded px-3 py-2 text-sm text-gray-700 mt-1"
        />
        {receiptFile && (
          <p className="text-sm text-green-700 mt-1">
            Selected: {receiptFile.name}
          </p>
        )}
      </div>

      {/* Buttons */}
      <div className="mt-6 flex justify-between">
        <Btn onClick={() => navigate("/dashboard/fuel")}>Back</Btn>
        <Btn onClick={handleValidation}>Submit</Btn>
      </div>
    </div>
  );
};

export default Add;
